import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import "./css/App.css";
import "./css/Responsive.css";
import "./css/index.css";
import store from "./redux/store";
import Pages from "./Routes/Pages";
import { ToastContainer } from "react-toastify";
import LocationApp from "./components/sharedComponents/Location/LocationApp";
import GTMInjector from "./components/sharedComponents/GTMInjector/GTMInjector";
import { SignalRProvider } from "./context/SignalRProvider";
import { NotificationProvider } from "./context/NotificationContext";
import { PermissionProvider } from "./context/PermissionContext";

function App() {
  return (
    <div>
      <GTMInjector />
      <ToastContainer />

      <Provider store={store}>
        <PermissionProvider>
          <NotificationProvider>
            <SignalRProvider>
              <Suspense fallback="loading........">
                <Pages />
              </Suspense>
            </SignalRProvider>
          </NotificationProvider>
        </PermissionProvider>
      </Provider>
    </div>
  );
}

export default App;
